<template>
    <div class="sta-table-2" :class="[category_id==5?'black-bg':'']">
        <ul class="sub-tab clearBoth" v-if="category_id==1">
            <li class="button t_btn-d" @click="onClick(0)" :class="{active: cur === 0}">号码</li>
            <li class="button t_btn-d" @click="onClick(1)" :class="{active: cur === 1}">大小</li>
            <li class="button t_btn-d" @click="onClick(2)" :class="{active: cur === 2}">单双</li>
            <li class="button t_btn-d" @click="onClick(3)" :class="{active: cur === 3}">龙虎</li>
            <li class="button t_btn-d" @click="onClick(4)" :class="{active: cur === 4}">合数</li>
            <li class="button t_btn-d" style="margin-left:0px;margin-top:5px" @click="onClick(5)" :class="{active: cur === 5}">尾数</li>
            <li class="button t_btn-d" style="margin-top:5px" @click="onClick(6)" :class="{active: cur === 6}">总和</li>
        </ul>
        <ul class="sub-tab clearBoth" v-else-if="category_id==2">
            <li class="button t_btn-d" @click="onClick(0)" :class="{active: cur === 0}">号码</li>
            <li class="button t_btn-d" @click="onClick(1)" :class="{active: cur === 1}">大小</li>
            <li class="button t_btn-d" @click="onClick(2)" :class="{active: cur === 2}">单双</li>
            <li class="button t_btn-d" @click="onClick(3)" :class="{active: cur === 3}">形态</li>
            <li class="button t_btn-d" @click="onClick(4)" :class="{active: cur === 4}">牛牛</li>
            <li class="button t_btn-d" style="margin-left:0px;margin-top:5px" @click="onClick(5)" :class="{active: cur === 5}">其它</li>
        </ul>
        <ul class="sub-tab clearBoth" v-else-if="category_id==3">
            <li class="button t_btn-d" @click="onClick(0)" :class="{active: cur === 0}">号码</li>
            <li class="button t_btn-d" @click="onClick(1)" :class="{active: cur === 1}">大小</li>
            <li class="button t_btn-d" @click="onClick(2)" :class="{active: cur === 2}">单双</li>
            <li class="button t_btn-d" @click="onClick(3)" :class="{active: cur === 3}">龙虎</li>
            <li class="button t_btn-d" @click="onClick(4)" :class="{active: cur === 4}">冠亚和</li>
        </ul>
        <ul class="sub-tab clearBoth" v-else-if="category_id==4">
            <li class="button t_btn-d" @click="onClick(0)" :class="{active: cur === 0}">号码</li>
            <li class="button t_btn-d" @click="onClick(8)" :class="{active: cur === 8}">生肖</li>
            <li class="button t_btn-d" @click="onClick(1)" :class="{active: cur === 1}">大小</li>
            <li class="button t_btn-d" @click="onClick(2)" :class="{active: cur === 2}">单双</li>
            <li class="button t_btn-d" @click="onClick(3)" :class="{active: cur === 3}">合大小</li>
            <li class="button t_btn-d" style="margin-left:0px;margin-top:5px" @click="onClick(4)" :class="{active: cur === 4}">合单双</li>
            <li class="button t_btn-d" style="margin-top:5px" @click="onClick(5)" :class="{active: cur === 5}">尾数</li>
            <li class="button t_btn-d" style="margin-top:5px" @click="onClick(6)" :class="{active: cur === 6}">家野</li>
            <li class="button t_btn-d" style="margin-top:5px" @click="onClick(7)" :class="{active: cur === 7}">总和</li>
        </ul>
        <ul class="sub-tab clearBoth" v-else-if="category_id==5">
            <li class="button t_btn-d" @click="onClick(0)" :class="{active: cur === 0}" style="display:none"></li>
        </ul>
        <CTable id="table-stat" style="overflow:auto"
              :head="head"
              :body="statistics"
      >
           <template slot="number_1" slot-scope="{data}">
             <span v-if="cur==0" :class="filterNumberColor(data.draw_results[0])">{{data.draw_results[0]}}</span>
             <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[0]>=25}">{{data.draw_results[0]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[0]>=11}">{{data.draw_results[0]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[0]%2!=0}">{{data.draw_results[0]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[0]/10)+data.draw_results[0]/1%10)>=7}">{{(parseInt(data.draw_results[0]/10)+data.draw_results[0]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[0]/10)+data.draw_results[0]/1%10)%2!=0}">{{(parseInt(data.draw_results[0]/10)+data.draw_results[0]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[0]/1%10>4}">{{data.draw_results[0]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[7]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[7])">{{filterSx(data.draw_results[7])}}</span>
            </template>
            <template slot="number_2" slot-scope="{data}">
             <span v-if="cur==0" :class="filterNumberColor(data.draw_results[1])">{{data.draw_results[1]}}</span>
             <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[1]>=25}">{{data.draw_results[1]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[1]>=11}">{{data.draw_results[1]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[1]%2!=0}">{{data.draw_results[1]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[1]/10)+data.draw_results[1]/1%10)>=7}">{{(parseInt(data.draw_results[1]/10)+data.draw_results[1]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[1]/10)+data.draw_results[1]/1%10)%2!=0}">{{(parseInt(data.draw_results[1]/10)+data.draw_results[1]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[1]/1%10>4}">{{data.draw_results[1]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[8]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[8])">{{filterSx(data.draw_results[8])}}</span>
            </template>
            <template slot="number_3" slot-scope="{data}">
             <span v-if="cur==0" :class="filterNumberColor(data.draw_results[2])">{{data.draw_results[2]}}</span>
             <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[2]>=25}">{{data.draw_results[2]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[2]>=11}">{{data.draw_results[2]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[2]%2!=0}">{{data.draw_results[2]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[2]/10)+data.draw_results[2]/1%10)>=7}">{{(parseInt(data.draw_results[2]/10)+data.draw_results[2]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[2]/10)+data.draw_results[2]/1%10)%2!=0}">{{(parseInt(data.draw_results[2]/10)+data.draw_results[2]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[2]/1%10>4}">{{data.draw_results[2]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[9]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[9])">{{filterSx(data.draw_results[9])}}</span>
            </template>
            <template slot="number_4" slot-scope="{data}">
             <span v-if="cur==0" :class="filterNumberColor(data.draw_results[3])">{{data.draw_results[3]}}</span>
             <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[3]>=25}">{{data.draw_results[3]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[3]>=11}">{{data.draw_results[3]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[3]%2!=0}">{{data.draw_results[3]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[3]/10)+data.draw_results[3]/1%10)>=7}">{{(parseInt(data.draw_results[3]/10)+data.draw_results[3]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[3]/10)+data.draw_results[3]/1%10)%2!=0}">{{(parseInt(data.draw_results[3]/10)+data.draw_results[3]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[3]/1%10>4}">{{data.draw_results[3]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[10]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[10])">{{filterSx(data.draw_results[10])}}</span>
            </template>
            <template slot="number_5" slot-scope="{data}">
            <span v-if="cur==0" :class="filterNumberColor(data.draw_results[4])">{{data.draw_results[4]}}</span>
            <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[4]>=25}">{{data.draw_results[4]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[4]>=11}">{{data.draw_results[4]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[4]%2!=0}">{{data.draw_results[4]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[4]/10)+data.draw_results[4]/1%10)>=7}">{{(parseInt(data.draw_results[4]/10)+data.draw_results[4]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[4]/10)+data.draw_results[4]/1%10)%2!=0}">{{(parseInt(data.draw_results[4]/10)+data.draw_results[4]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[4]/1%10>4}">{{data.draw_results[4]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[11]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[11])">{{filterSx(data.draw_results[11])}}</span>
            </template>
            <template slot="number_6" slot-scope="{data}">
             <span v-if="cur==0" :class="filterNumberColor(data.draw_results[5])">{{data.draw_results[5]}}</span>
             <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[5]>=25}">{{data.draw_results[5]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[5]>=11}">{{data.draw_results[5]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[5]%2!=0}">{{data.draw_results[5]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[5]/10)+data.draw_results[5]/1%10)>=7}">{{(parseInt(data.draw_results[5]/10)+data.draw_results[5]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[5]/10)+data.draw_results[5]/1%10)%2!=0}">{{(parseInt(data.draw_results[5]/10)+data.draw_results[5]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[5]/1%10>4}">{{data.draw_results[5]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[12]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[12])">{{filterSx(data.draw_results[12])}}</span>
            </template>
            <template slot="number_7" slot-scope="{data}">
             <span v-if="cur==0" :class="filterNumberColor(data.draw_results[6])">{{data.draw_results[6]}}</span>
             <span v-else-if="cur==1&&category_id==4" :class="{red: data.draw_results[6]>=25}">{{data.draw_results[6]>=25?"大":"小"}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[6]>=11}">{{data.draw_results[6]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[6]%2!=0}">{{data.draw_results[6]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==3" :class="{red: (parseInt(data.draw_results[6]/10)+data.draw_results[6]/1%10)>=7}">{{(parseInt(data.draw_results[6]/10)+data.draw_results[6]/1%10)>=7?"大":"小"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[6]/10)+data.draw_results[6]/1%10)%2!=0}">{{(parseInt(data.draw_results[6]/10)+data.draw_results[6]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[6]/1%10>4}">{{data.draw_results[6]/1%10>4?"大":"小"}}</span>
             <span v-else-if="cur==8">{{data.draw_results[13]}}</span>
             <span v-else-if="cur==6" :class="filterSxColor(data.draw_results[13])">{{filterSx(data.draw_results[13])}}</span>
            </template>
            <template slot="number_8" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[7]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[7]>=11}">{{data.draw_results[7]>=11?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[7]%2!=0}">{{data.draw_results[7]%2==0?"双":"单"}}</span>
             <span v-else-if="cur==4" :class="{red: (parseInt(data.draw_results[7]/10)+data.draw_results[7]/1%10)%2!=0}">{{(parseInt(data.draw_results[7]/10)+data.draw_results[7]/1%10)%2==0?"双":"单"}}</span>
             <span v-else-if="cur==5" :class="{red: data.draw_results[7]/1%10>4}">{{data.draw_results[7]/1%10>4?"大":"小"}}</span>
            </template>

            <template slot="lh1" slot-scope="{data}">
            <span :class="{red: data.draw_results[0]>data.draw_results[data.draw_results.length-1]}">{{data.draw_results[0]>data.draw_results[data.draw_results.length-1]?"龙":"虎"}}</span>
            </template>
            <template slot="lh2" slot-scope="{data}">
            <span :class="{red: data.draw_results[1]>data.draw_results[data.draw_results.length-2]}">{{data.draw_results[1]>data.draw_results[data.draw_results.length-2]?"龙":"虎"}}</span>
            </template>
            <template slot="lh3" slot-scope="{data}">
            <span :class="{red: data.draw_results[2]>data.draw_results[data.draw_results.length-3]}">{{data.draw_results[2]>data.draw_results[data.draw_results.length-3]?"龙":"虎"}}</span>
            </template>
            <template slot="lh4" slot-scope="{data}">
            <span :class="{red: data.draw_results[3]>data.draw_results[data.draw_results.length-4]}">{{data.draw_results[3]>data.draw_results[data.draw_results.length-4]?"龙":"虎"}}</span>
            </template>
             <template slot="lh5" slot-scope="{data}">
            <span :class="{red: data.draw_results[4]>data.draw_results[data.draw_results.length-5]}">{{data.draw_results[4]>data.draw_results[data.draw_results.length-5]?"龙":"虎"}}</span>
            </template>

            <template slot="sum_ds" slot-scope="{data}">
            <span :class="{red: data.sum%2!=0}">{{data.sum%2==0?"双":"单"}}</span>
            </template>
            <template slot="sum_dx" slot-scope="{data}">
            <span v-if="data.sum>=85" class="red">大</span>
            <span v-else-if="data.sum==84" class="green">和</span>
            <span v-else>小</span>
            </template>
            <template slot="sum_ws" slot-scope="{data}">
            <span :class="{red: data.sum/1%10>4}">{{data.sum/1%10>4?"大":"小"}}</span>
            </template>

            <template slot="number_ssc_1" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[0]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[0]>=5}">{{data.draw_results[0]>=5?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[0]%2!=0}">{{data.draw_results[0]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_ssc_2" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[1]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[1]>=5}">{{data.draw_results[1]>=5?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[1]%2!=0}">{{data.draw_results[1]%2==0?"双":"单"}}</span>
            </template>
            <template slot="number_ssc_3" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[2]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[2]>=5}">{{data.draw_results[2]>=5?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[2]%2!=0}">{{data.draw_results[2]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_ssc_4" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[3]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[3]>=5}">{{data.draw_results[3]>=5?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[3]%2!=0}">{{data.draw_results[3]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_ssc_5" slot-scope="{data}">
            <span v-if="cur==0">{{data.draw_results[4]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[4]>=5}">{{data.draw_results[4]>=5?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[4]%2!=0}">{{data.draw_results[4]%2==0?"双":"单"}}</span>
             </template>

             <template slot="xingtai1" slot-scope="{data}">
              <span>{{data.xingtai[0]}}</span>
             </template>
             <template slot="xingtai2" slot-scope="{data}">
              <span>{{data.xingtai[1]}}</span>
             </template>
             <template slot="xingtai3" slot-scope="{data}">
              <span>{{data.xingtai[2]}}</span>
             </template>

              <template slot="niuji" slot-scope="{data}">
              <span>{{data.niuniu[0]}}</span>
             </template>

             <template slot="niu_dx" slot-scope="{data}">
              <span :class="{red: data.niuniu[1]=='大'}">{{data.niuniu[1]}}</span>
             </template>

             <template slot="niu_ds" slot-scope="{data}">
             <span :class="{red: data.niuniu[2]=='单'}">{{data.niuniu[2]}}</span>
             </template>

            <template slot="sum_ssc_dx" slot-scope="{data}">
            <span :class="{red: data.sum>=23}">{{data.sum>=23?"大":"小"}}</span>
            </template>
            <template slot="sum_ssc_lh" slot-scope="{data}">
            <span v-if="data.draw_results[0]>data.draw_results[4]" class="red">龙</span>
            <span v-else-if="data.draw_results[0]==data.draw_results[4]" class="green">和</span>
            <span v-else>虎</span>
            </template>

            <template slot="number_pk10_1" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[0]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[0]>=6}">{{data.draw_results[0]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[0]%2!=0}">{{data.draw_results[0]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_2" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[1]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[1]>=6}">{{data.draw_results[1]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[1]%2!=0}">{{data.draw_results[1]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_3" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[2]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[2]>=6}">{{data.draw_results[2]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[2]%2!=0}">{{data.draw_results[2]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_4" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[3]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[3]>=6}">{{data.draw_results[3]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[3]%2!=0}">{{data.draw_results[3]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_5" slot-scope="{data}">
            <span v-if="cur==0">{{data.draw_results[4]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[4]>=6}">{{data.draw_results[4]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[4]%2!=0}">{{data.draw_results[4]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_6" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[5]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[5]>=6}">{{data.draw_results[5]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[5]%2!=0}">{{data.draw_results[5]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_7" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[6]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[6]>=6}">{{data.draw_results[6]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[6]%2!=0}">{{data.draw_results[6]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_8" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[7]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[7]>=6}">{{data.draw_results[7]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[7]%2!=0}">{{data.draw_results[7]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_9" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[8]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[8]>=6}">{{data.draw_results[8]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[8]%2!=0}">{{data.draw_results[8]%2==0?"双":"单"}}</span>
             </template>
            <template slot="number_pk10_10" slot-scope="{data}">
             <span v-if="cur==0">{{data.draw_results[9]}}</span>
             <span v-else-if="cur==1" :class="{red: data.draw_results[9]>=6}">{{data.draw_results[9]>=6?"大":"小"}}</span>
             <span v-else-if="cur==2" :class="{red: data.draw_results[9]%2!=0}">{{data.draw_results[9]%2==0?"双":"单"}}</span>
             </template>
             <template slot="sum_pk10_dx" slot-scope="{data}">
            <span :class="{red: data.sum>11}">{{data.sum>11?"大":"小"}}</span>
            </template>
            <template slot="sum_lhc_dx" slot-scope="{data}">
            <span :class="{red: data.sum>=175}">{{data.sum>=175?"大":"小"}}</span>
            </template>
            <template slot="even_odd" slot-scope="{data}">
            <span :class="[data.even_odd=='单'?'red':'white']">{{data.even_odd}}</span>
            </template>
            <template slot="fanhao" slot-scope="{data}">
            <span class="ft-number" :class="'number-'+data.fanhao">{{data.fanhao}}</span>
            </template>
      </CTable>
    </div>
</template>

<script>
import CTable from '../../dialog/table';
import { filterNumber } from "../../../utils/objectFactory";
import {mapState} from 'vuex';
  export default {
    name: "sta_table2",
    components: {CTable},
    computed: {
      head() {
        if(this.category_id==1)
        {
            if(this.cur==0 || this.cur==1 || this.cur==2 || this.cur==4 || this.cur==5)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '1', value: 'number_1'},
                {label: '2', value: 'number_2'},
                {label: '3', value: 'number_3'},
                {label: '4', value: 'number_4'},
                {label: '5', value: 'number_5'},
                {label: '6', value: 'number_6'},
                {label: '7', value: 'number_7'},
                {label: '8', value: 'number_8'},
              ];
            }
            else if(this.cur==3)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '1', value: 'lh1'},
                {label: '2', value: 'lh2'},
                {label: '3', value: 'lh3'},
                {label: '4', value: 'lh4'},
              ];
            }
            else if(this.cur==6)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '和值', value: 'sum'},
                {label: '单双', value: 'sum_ds'},
                {label: '大小', value: 'sum_dx'},
                {label: '尾数', value: 'sum_ws'},
              ];
            }
        }
        else if(this.category_id==2)
        {
            if(this.cur==0 || this.cur==1 || this.cur==2)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '1', value: 'number_ssc_1'},
                {label: '2', value: 'number_ssc_2'},
                {label: '3', value: 'number_ssc_3'},
                {label: '4', value: 'number_ssc_4'},
                {label: '5', value: 'number_ssc_5'}
              ];
            }
            else if(this.cur==3)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '前三', value: 'xingtai1'},
                {label: '中三', value: 'xingtai2'},
                {label: '后三', value: 'xingtai3'},
              ];
            }
            else if(this.cur==4)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '牛牛', value: 'niuji'},
                {label: '牛单双', value: 'niu_ds'},
                {label: '牛大小', value: 'niu_dx'},
              ];
            }
            else if(this.cur==5)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '总和', value: 'sum'},
                {label: '总单双', value: 'sum_ds'},
                {label: '总大小', value: 'sum_ssc_dx'},
                {label: '龙虎和', value: 'sum_ssc_lh'},
              ];
            }
        }
        else if(this.category_id==3)
        {
            if(this.cur==0 || this.cur==1 || this.cur==2)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '1', value: 'number_pk10_1'},
                {label: '2', value: 'number_pk10_2'},
                {label: '3', value: 'number_pk10_3'},
                {label: '4', value: 'number_pk10_4'},
                {label: '5', value: 'number_pk10_5'},
                {label: '6', value: 'number_pk10_6'},
                {label: '7', value: 'number_pk10_7'},
                {label: '8', value: 'number_pk10_8'},
                {label: '9', value: 'number_pk10_9'},
                {label: '10', value: 'number_pk10_10'}
              ];
            }
            else if(this.cur==3)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '1', value: 'lh1'},
                {label: '2', value: 'lh2'},
                {label: '3', value: 'lh3'},
                {label: '4', value: 'lh4'},
                {label: '5', value: 'lh5'},
              ];
            }
            else if(this.cur==4)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '冠亚和值', value: 'sum'},
                {label: '单双', value: 'sum_ds'},
                {label: '大小', value: 'sum_pk10_dx'},
              ];
            }
        }else if(this.category_id==4)
        {
            if(this.cur==0 || this.cur==8 || this.cur==1 || this.cur==2 || this.cur==3 || this.cur==4 || this.cur==5 || this.cur==6)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '1', value: 'number_1'},
                {label: '2', value: 'number_2'},
                {label: '3', value: 'number_3'},
                {label: '4', value: 'number_4'},
                {label: '5', value: 'number_5'},
                {label: '6', value: 'number_6'},
                {label: '7', value: 'number_7'}
              ];
            }else if(this.cur==7)
            {
              return [
                {label: '期数', value: 'period'},
                {label: '和值', value: 'sum'},
                {label: '单双', value: 'sum_ds'},
                {label: '大小', value: 'sum_lhc_dx'},
              ];
            }
        }
        else if(this.category_id==5)
        {
            return [
              {label: '期数', value: 'period'},
              //{label: '号码', value: 'number'},
              {label: '番号', value: 'fanhao'},
              {label: '单双', value: 'even_odd'},
            ];
        }
      },
      ...mapState({
        statistics: state => state.home.statistics
      })
    },
    data() {
      return {
        cur: 0,
        category_id:this.$route.query.category_id
      }
    },
    mounted(){
      //console.log(this.$route.query.lottery_type);
    },
    methods: {
      onClick(tag) {
        this.cur = tag;
      },
      // 过滤当前number的背景图片颜色
      filterNumberColor(checkNumber) {
        if (this.category_id!=4)
          return '';
        const isFilterNumber = filterNumber(checkNumber);
        if (isFilterNumber) {
          return isFilterNumber;
        }
        if (checkNumber && isNaN(Number(checkNumber))) {
          if (checkNumber.indexOf('红') > -1) return 'banbo-red';
          if (checkNumber.indexOf('绿') > -1) return 'banbo-green';
          if (checkNumber.indexOf('蓝') > -1) return 'banbo-blue';
          return 'banbo-yellow';
        }
        return '';
      },
      filterSx(checkNumber){
        if (this.category_id!=4)
          return '';
        if(checkNumber=='猪'||checkNumber=='鸡'||checkNumber=='狗'||checkNumber=='马'||checkNumber=='牛'||checkNumber=='羊')
          return '家';
        return '野';
      },
      filterSxColor(checkNumber){
        if (this.category_id!=4)
          return '';
        if(checkNumber=='猪'||checkNumber=='鸡'||checkNumber=='狗'||checkNumber=='马'||checkNumber=='牛'||checkNumber=='羊')
          return 'red';
        return '';
      }
    }
  }
</script>

<style scoped lang="stylus">
.white{color:white}
.number-red{color:red}
.number-green{color:green}
.number-blue{color:blue}
    .sta-table-2
        font-size 12px
        /*border-left 1px solid #e0e0e0
        border-right 1px solid #e0e0e0*/
        .sub-tab
            padding-top 7px
            padding-bottom 7px
            > li
                width 36px
                float left
                height 22px
                line-height 22px
            li + li
                margin-left 2px
.ft-number{
    width: 30px;
    height: 30px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background-size: contain;
    font-size: 13px;
    font-weight: bold;
    margin: 0 auto;
}
.number-1 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../../assets/1.fw.png') no-repeat center center;
  }

  .number-2 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../../assets/2.fw.png') no-repeat center center;
  }

  .number-3 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../../assets/3.fw.png') no-repeat center center;
  }

  .number-4 {
    font-size: 14px;
    font-weight: bold;
    color:#363636;
    background: url('../../../assets/4.fw.png') no-repeat center center;
  }
  .black-bg #table-stat{background:#0A0A0A}
</style>


// WEBPACK FOOTER //
// src/components/c_statistics/sta-table/sta_table2.vue